import { createFileRoute, Link } from "@tanstack/react-router";
import { useSEO } from "../../hooks/useSEO";
import { SEO_CONFIG } from "../../seo/seoConfig";
import { Breadcrumb } from "../../components/shared/Breadcrumb";
import { integrationsByCategory, TOTAL_INTEGRATION_PAGES } from "../../data/integrations";

export const Route = createFileRoute("/integrations/")({
  component: IntegrationsHub,
});

function IntegrationsHub() {
  useSEO(SEO_CONFIG["/integrations"]!);
  const groups = integrationsByCategory();

  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto max-w-4xl px-4 py-12 sm:py-16">
        <div className="mb-6">
          <Breadcrumb items={[{ name: "Home", url: "/" }, { name: "Integrations", url: "/integrations" }]} />
        </div>

        <h1 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl">Integrations</h1>
        <p className="mt-3 text-lg text-foreground/80">
          ProvenLeap connects to {TOTAL_INTEGRATION_PAGES} marketing platforms — and every integration is
          included on every plan, including the free Solo plan. Connect your clients' data sources and report on
          them in branded reports and live dashboards.
        </p>

        <div className="mt-10 space-y-10">
          {groups.map((group) => (
            <section key={group.category} aria-labelledby={`cat-${group.category}`}>
              <h2 id={`cat-${group.category}`} className="mb-3 text-xl font-semibold tracking-tight">
                {group.category}
              </h2>
              <ul className="grid gap-3 sm:grid-cols-2">
                {group.items.map((integration) => (
                  <li key={integration.slug}>
                    <Link
                      to="/integrations/$slug"
                      params={{ slug: integration.slug }}
                      className="block rounded-xl border-[0.5px] border-input p-4 transition-shadow hover:shadow-sm"
                    >
                      <span className="font-medium text-foreground">{integration.name}</span>
                      <span className="mt-0.5 block text-sm text-muted-foreground">{integration.tagline}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
